import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    RouterStateSnapshot,
} from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { UserAuthService } from './user-auth.service';

export const epiHomeRedirectGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> => {
    const userAuthService = inject(UserAuthService);
    const configService = inject(ConfigService);

    const nonBlockingGuards = route.data.nonBlockingGuards as boolean;
    const redirect = userAuthService.isAuthenticated$.pipe(
        take(1),
        switchMap((isAuthenticated) => {
            if (
                configService.isEmbedded &&
                !isAuthenticated &&
                !state.url.toLowerCase().includes('_branch_match_id')
            ) {
                window.location.href = configService.siteUrl;
            }

            return of(true);
        })
    );

    if (nonBlockingGuards) {
        redirect.subscribe();
        return of(true);
    } else {
        return redirect;
    }
};
